var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#82AFFF"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    style: {
      fill: "#F5F5F5"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.33,
    style: {
      fill: "#82AFFF"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC855"
    },
    points: "253.455,205.688 247.67,208.58 252.992,210.778 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M256,312.589c-32.153,0-58.31-26.159-58.31-58.31c0-19.974,10.053-38.339,26.892-49.128l1.497,2.337   c-16.038,10.277-25.612,27.769-25.612,46.791c0,30.622,24.913,55.533,55.533,55.533V312.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M222.628,316.228c2.222,0.453,5.649-0.133,9.17-1.773s6.174-3.888,7.256-5.88   c-2.222-0.453-5.649,0.133-9.17,1.773C226.364,311.989,223.711,314.236,222.628,316.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M239.054,308.575c0.453-2.222-0.133-5.649-1.773-9.17c-1.64-3.521-3.888-6.174-5.88-7.256   c-0.453,2.222,0.133,5.649,1.773,9.17C234.815,304.839,237.062,307.492,239.054,308.575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M211.011,309.097c2.131,0.774,5.607,0.698,9.331-0.408s6.678-2.939,8.041-4.751   c-2.131-0.774-5.607-0.698-9.331,0.408C215.329,305.452,212.375,307.285,211.011,309.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M228.383,303.938c0.774-2.131,0.698-5.607-0.408-9.331c-1.106-3.723-2.939-6.678-4.751-8.041   c-0.774,2.131-0.698,5.607,0.408,9.331S226.572,302.575,228.383,303.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M200.266,299.374c1.957,1.144,5.391,1.694,9.252,1.275s7.097-1.692,8.763-3.229   c-1.957-1.144-5.391-1.694-9.252-1.275S201.932,297.837,200.266,299.374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M218.281,297.419c1.144-1.957,1.694-5.391,1.275-9.252c-0.419-3.861-1.692-7.097-3.229-8.763   c-1.144,1.957-1.694,5.391-1.275,9.252C215.471,292.517,216.744,295.753,218.281,297.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M191.383,285.947c1.724,1.473,5.006,2.621,8.88,2.893s7.284-0.409,9.197-1.626   c-1.724-1.473-5.006-2.621-8.88-2.893C196.705,284.049,193.295,284.729,191.383,285.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M209.46,287.213c1.473-1.724,2.621-5.006,2.893-8.88c0.271-3.874-0.409-7.284-1.626-9.197   c-1.473,1.724-2.621,5.006-2.893,8.88C207.562,281.891,208.242,285.301,209.46,287.213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M186.182,271.156c1.376,1.802,4.342,3.616,8.073,4.696c3.731,1.08,7.207,1.133,9.333,0.345   c-1.376-1.802-4.342-3.616-8.073-4.696C191.785,270.42,188.308,270.368,186.182,271.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M203.588,276.197c1.802-1.376,3.616-4.342,4.696-8.073s1.133-7.207,0.345-9.333   c-1.802,1.376-3.616,4.342-4.696,8.073C202.853,270.594,202.8,274.071,203.588,276.197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M183.982,253.887c0.866,2.095,3.266,4.611,6.594,6.614c3.327,2.003,6.674,2.948,8.931,2.733   c-0.866-2.095-3.266-4.611-6.594-6.614C189.585,254.617,186.239,253.672,183.982,253.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M199.507,263.234c2.095-0.866,4.611-3.266,6.614-6.594c2.003-3.327,2.948-6.674,2.733-8.931   c-2.095,0.866-4.611,3.266-6.614,6.594C200.236,257.631,199.292,260.977,199.507,263.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M186.068,237.583c0.407,2.23,2.227,5.193,5.061,7.849s5.907,4.282,8.159,4.544   c-0.407-2.23-2.227-5.193-5.061-7.849S188.32,237.845,186.068,237.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M199.288,249.976c2.23-0.407,5.193-2.227,7.849-5.061s4.282-5.907,4.544-8.159   c-2.23,0.407-5.193,2.227-7.849,5.061S199.551,247.725,199.288,249.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M194.259,219.94c-0.467,2.219,0.097,5.65,1.715,9.181s3.849,6.198,5.834,7.293   c0.467-2.219-0.097-5.65-1.715-9.181C198.475,223.703,196.244,221.035,194.259,219.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M201.808,236.414c2.219,0.467,5.65-0.097,9.181-1.715s6.198-3.849,7.293-5.834   c-2.219-0.467-5.65,0.097-9.181,1.715C205.57,232.199,202.903,234.429,201.808,236.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M204.054,206.875c-1.046,2.012-1.425,5.468-0.816,9.304c0.609,3.836,2.041,7.005,3.659,8.593   c1.046-2.012,1.425-5.468,0.816-9.304C207.104,211.632,205.672,208.463,204.054,206.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M206.897,224.771c2.012,1.046,5.468,1.425,9.304,0.816s7.005-2.041,8.593-3.659   c-2.012-1.046-5.468-1.425-9.304-0.816S208.486,223.154,206.897,224.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M213.66,197.781c-1.331,1.836-2.215,5.198-2.177,9.082s0.987,7.229,2.353,9.038   c1.331-1.836,2.215-5.198,2.177-9.082S215.026,199.59,213.66,197.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M213.835,215.901c1.836,1.331,5.198,2.215,9.082,2.177s7.229-0.987,9.038-2.353   c-1.836-1.331-5.198-2.215-9.082-2.177C218.99,213.586,215.645,214.535,213.835,215.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M218.497,211.138c2.26,0.183,5.592-0.808,8.891-2.858c3.299-2.05,5.664-4.599,6.5-6.706   c-2.26-0.183-5.592,0.808-8.891,2.858C221.698,206.481,219.334,209.03,218.497,211.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M256,312.589v-2.777c30.621,0,55.533-24.911,55.533-55.533c0-19.022-9.575-36.514-25.612-46.791   l1.497-2.337c16.839,10.789,26.892,29.155,26.892,49.128C314.31,286.43,288.153,312.589,256,312.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M289.372,316.228c-2.222,0.453-5.649-0.133-9.17-1.773c-3.521-1.64-6.174-3.888-7.256-5.88   c2.222-0.453,5.649,0.133,9.17,1.773C285.636,311.989,288.289,314.236,289.372,316.228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M272.946,308.575c-0.453-2.222,0.133-5.649,1.773-9.17c1.64-3.521,3.888-6.174,5.88-7.256   c0.453,2.222-0.133,5.649-1.773,9.17C277.185,304.839,274.938,307.492,272.946,308.575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M300.989,309.097c-2.131,0.774-5.607,0.698-9.331-0.408c-3.723-1.106-6.678-2.939-8.041-4.751   c2.131-0.774,5.607-0.698,9.331,0.408S299.625,307.285,300.989,309.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M283.617,303.938c-0.774-2.131-0.698-5.607,0.408-9.331c1.106-3.723,2.939-6.678,4.751-8.041   c0.774,2.131,0.698,5.607-0.408,9.331S285.428,302.575,283.617,303.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M311.734,299.374c-1.957,1.144-5.391,1.694-9.252,1.275c-3.861-0.419-7.097-1.692-8.763-3.229   c1.957-1.144,5.391-1.694,9.252-1.275C306.832,296.564,310.068,297.837,311.734,299.374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M293.719,297.419c-1.144-1.957-1.694-5.391-1.275-9.252c0.419-3.861,1.692-7.097,3.229-8.763   c1.144,1.957,1.694,5.391,1.275,9.252C296.529,292.517,295.256,295.753,293.719,297.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M320.617,285.947c-1.724,1.473-5.006,2.621-8.88,2.893c-3.874,0.271-7.284-0.409-9.197-1.626   c1.724-1.473,5.006-2.621,8.88-2.893S318.705,284.729,320.617,285.947z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M302.54,287.213c-1.473-1.724-2.621-5.006-2.893-8.88c-0.271-3.874,0.409-7.284,1.626-9.197   c1.473,1.724,2.621,5.006,2.893,8.88C304.438,281.891,303.758,285.301,302.54,287.213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M325.818,271.156c-1.376,1.802-4.342,3.616-8.073,4.696s-7.207,1.133-9.333,0.345   c1.376-1.802,4.342-3.616,8.073-4.696C320.215,270.42,323.692,270.368,325.818,271.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M308.412,276.197c-1.802-1.376-3.616-4.342-4.696-8.073c-1.08-3.731-1.133-7.207-0.345-9.333   c1.802,1.376,3.616,4.342,4.696,8.073C309.147,270.594,309.2,274.071,308.412,276.197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M328.018,253.887c-0.866,2.095-3.266,4.611-6.594,6.614c-3.327,2.003-6.674,2.948-8.931,2.733   c0.866-2.095,3.266-4.611,6.594-6.614C322.414,254.617,325.761,253.672,328.018,253.887z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M312.493,263.234c-2.095-0.866-4.611-3.266-6.614-6.594s-2.948-6.674-2.733-8.931   c2.095,0.866,4.611,3.266,6.614,6.594C311.764,257.631,312.708,260.977,312.493,263.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M325.932,237.583c-0.407,2.23-2.227,5.193-5.061,7.849s-5.907,4.282-8.159,4.544   c0.407-2.23,2.227-5.193,5.061-7.849C320.606,239.471,323.68,237.845,325.932,237.583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M312.712,249.976c-2.23-0.407-5.193-2.227-7.849-5.061s-4.282-5.907-4.544-8.159   c2.23,0.407,5.193,2.227,7.849,5.061S312.449,247.725,312.712,249.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M317.741,219.94c0.467,2.219-0.097,5.65-1.715,9.181s-3.849,6.198-5.834,7.293   c-0.467-2.219,0.097-5.65,1.715-9.181C313.525,223.703,315.756,221.035,317.741,219.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M310.192,236.414c-2.219,0.467-5.65-0.097-9.181-1.715s-6.198-3.849-7.293-5.834   c2.219-0.467,5.65,0.097,9.181,1.715C306.43,232.199,309.097,234.429,310.192,236.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M307.946,206.875c1.046,2.012,1.425,5.468,0.816,9.304c-0.609,3.836-2.041,7.005-3.659,8.593   c-1.046-2.012-1.425-5.468-0.816-9.304S306.328,208.463,307.946,206.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M305.103,224.771c-2.012,1.046-5.468,1.425-9.304,0.816c-3.836-0.609-7.005-2.041-8.593-3.659   c2.012-1.046,5.468-1.425,9.304-0.816C300.345,221.722,303.514,223.154,305.103,224.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M298.34,197.781c1.331,1.836,2.215,5.198,2.177,9.082s-0.987,7.229-2.353,9.038   c-1.331-1.836-2.215-5.198-2.177-9.082S296.974,199.59,298.34,197.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M298.165,215.901c-1.836,1.331-5.198,2.215-9.082,2.177s-7.229-0.987-9.038-2.353   c1.836-1.331,5.198-2.215,9.082-2.177C293.01,213.586,296.355,214.535,298.165,215.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M293.503,211.138c-2.26,0.183-5.592-0.808-8.891-2.858c-3.299-2.05-5.664-4.599-6.5-6.706   c2.26-0.183,5.592,0.808,8.891,2.858C290.302,206.481,292.666,209.03,293.503,211.138z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#966446"
    },
    d: "M224.168,299.675l-10.107,10.107l-4.984-9.968l14.952-14.952l4.984,4.984l-1.44,4.319  C226.881,296.241,225.715,298.128,224.168,299.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9B9"
    },
    d: "M278.853,225.054l-54.824,54.824c-1.376,1.376-1.376,3.608,0,4.984l2.492,2.492l9.968-9.968  l39.872-44.856l4.984-4.984L278.853,225.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#966446"
    },
    d: "M237.521,271.37c-0.661,0.661-1.032,1.557-1.032,2.492v3.524l39.872-44.856L237.521,271.37z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A0A0A0"
    },
    points: "281.345,227.546 278.853,225.054 276.361,227.546 278.853,230.038 281.345,232.53   308.757,200.134 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#966446"
    },
    d: "M290.609,299.675l10.107,10.107l4.984-9.968l-14.952-14.952l-4.984,4.984l1.44,4.319  C287.896,296.241,289.061,298.128,290.609,299.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9B9"
    },
    d: "M235.924,225.054l54.824,54.824c1.376,1.376,1.376,3.608,0,4.984l-2.492,2.492l-9.968-9.968  l-39.872-44.856l-4.984-4.984L235.924,225.054z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#966446"
    },
    d: "M277.256,271.37c0.661,0.661,1.032,1.557,1.032,2.492v3.524l-39.872-44.856L277.256,271.37z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A0A0A0"
    },
    points: "233.432,227.546 235.924,225.054 238.416,227.546 235.924,230.038 233.432,232.53   206.02,200.134 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9B9"
    },
    d: "M236.932,297.601l2.476,2.259c9.035-9.906,24.847-27.241,49.911-49.746  C289.32,250.114,268.555,262.932,236.932,297.601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M229.926,307.77L229.926,307.77c-0.889-0.811-0.952-2.189-0.141-3.078l5.308-5.82  c0.811-0.889,2.189-0.952,3.078-0.141l0,0c0.889,0.811,0.952,2.189,0.141,3.078l-5.308,5.82  C232.193,308.517,230.815,308.581,229.926,307.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC855"
    },
    d: "M234.922,295.768l-1.438,0.64c-1.279,0.636-4.643,2.54-5.223,5.251  c-0.276,1.285,0.113,2.536,1.111,3.721c0.094-0.245,0.225-0.481,0.412-0.687l0.668-0.732c-0.452-0.656-0.691-1.3-0.554-1.947  c0.363-1.697,2.627-3.21,4.048-3.96l6.359,5.8l1.581-1.733L234.922,295.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9B9B9"
    },
    d: "M277.82,300.344l-2.476,2.259c-9.035-9.906-24.847-27.241-49.911-49.746  C225.432,252.856,246.197,265.674,277.82,300.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M284.826,310.512L284.826,310.512c0.889-0.811,0.952-2.189,0.141-3.078l-5.308-5.82  c-0.811-0.889-2.189-0.952-3.078-0.141l0,0c-0.889,0.811-0.952,2.189-0.141,3.078l5.308,5.82  C282.559,311.259,283.937,311.323,284.826,310.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC855"
    },
    d: "M279.83,298.51l1.438,0.64c1.279,0.636,4.643,2.54,5.223,5.251c0.276,1.285-0.114,2.536-1.111,3.721  c-0.094-0.245-0.224-0.481-0.412-0.687l-0.668-0.732c0.452-0.656,0.691-1.3,0.554-1.947c-0.363-1.697-2.627-3.21-4.048-3.96  l-6.359,5.8l-1.581-1.733L279.83,298.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#69B469"
    },
    d: "M258.47,208.632c0.194-0.481,0.307-1.005,0.307-1.556c0-2.3-1.865-4.165-4.165-4.165  s-4.165,1.865-4.165,4.165c0,1.371,0.671,2.577,1.693,3.336c-1.505,12.098,10.421,13.021,14.967,14.712  c6.896,2.565,15.546,7.757,15.002,22.266c-0.529,14.104-9.448,27.713-9.448,27.713l7.404-10.065  c-2.708,11.451-9.029,26.037-24.064,43.385c0,0,10.28-10.056,18.858-23.023c-6.311,14.849-13.305,28.577-13.305,28.577  s12.379-16.082,22.387-43.906C296.073,236.337,270.551,216.071,258.47,208.632z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.56,
    y: 258.44,
    style: {
      fill: "#F4E08F"
    },
    width: 11.11,
    height: 5.553
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ECD077"
    },
    cx: 236.56,
    cy: 264,
    r: 5.553
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ECD077"
    },
    cx: 236.56,
    cy: 227.9,
    r: 5.553
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCF0A8"
    },
    d: "M269.883,233.454c3.067,0,5.553-2.487,5.553-5.553c0-3.067-2.486-5.553-5.553-5.553h-33.32  c3.067,0,5.553,2.486,5.553,5.553c0,3.067-2.486,5.553-5.553,5.553s-5.553-2.487-5.553-5.553c0,9.321,7.801,20.593,10.316,30.543  c0,0,0.79,2.486,0.79,5.553c0,3.067-2.486,5.553-5.553,5.553h33.32c3.067,0,5.553-2.487,5.553-5.553  c0-9.321-7.801-20.593-10.316-30.543L269.883,233.454L269.883,233.454z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4E08F"
    },
    d: "M242.117,227.901c0,3.067-2.486,5.553-5.553,5.553h33.32c3.067,0,5.553-2.487,5.553-5.553H242.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4E08F"
    },
    d: "M242.117,263.998c0,3.067-2.486,5.553-5.553,5.553h33.32c3.067,0,5.553-2.487,5.553-5.553H242.117z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGt);
export default __webpack_public_path__ + "static/media/GT.8955809a40d85e1ec50a3d92da442029.svg";
export { ForwardRef as ReactComponent };